import { render, staticRenderFns } from "./SEOpage.vue?vue&type=template&id=11422d17&"
import script from "./SEOpage.vue?vue&type=script&lang=js&"
export * from "./SEOpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports